import { useFormatNumber } from '~/i18n/hooks/useFormatNumber/useFormatNumber';

import { StatusType } from '../../types/StatusType';
import { Theme } from '../../types/Theme';
import { Box } from '../Box/Box';
import { Text } from '../Text/Text';

interface Props {
  /** The number to be displayed */
  count: number;
  /** status determines the color of the circle */
  status?: StatusType | 'cta';
  /** If 'dark' theme and no status, will inverse colors. If status is provided, will override theme. */
  theme?: Theme;
}

export const Count = ({ count, status, theme = 'light' }: Props) => {
  const formatNumber = useFormatNumber();
  const ninetyNine = formatNumber(99);
  const isOverLimit = count > 99;
  const displayCount = isOverLimit ? ninetyNine + '+' : formatNumber(count);
  const tooltip = isOverLimit ? formatNumber(count) : undefined;

  const bg =
    status === 'cta'
      ? '#4F73FF'
      : status
        ? `status.${status}`
        : theme === 'dark'
          ? 'background'
          : 'status.info';

  return (
    <Box
      role="status"
      align="center"
      bg={bg}
      borderRadius="50%"
      display="flex"
      justify="center"
      tooltip={tooltip}
      h={22}
      w={22}
    >
      <Text
        color={
          theme === 'dark' && !status ? 'text.primary' : 'inverse.text.primary'
        }
        variant="tiny-bold"
      >
        {displayCount}
      </Text>
    </Box>
  );
};
